import { calculatePriceWithBreaks, roundToTwoPlaces, addCommas } from '../pricing/price-calculator'

/**
 * Updates the total price display for a given box
 * @param {string} box - The box number
 * @param {function} [priceModifierFn] - Optional function to get price modifier, defaults to calculating from checkboxes
 */
export function updateTotalPrice(box, priceModifierFn = null) {
  const quantityInput = document.getElementById('quantity')
  const quantity = quantityInput ? Number(quantityInput.value) : 1
  
  const putupPrice = calculatePriceWithBreaks(quantity, box)
  
  // Use provided function or fall back to default calculation
  const priceModifier = priceModifierFn ? priceModifierFn() : calculateDefaultPriceModifier(box)
  
  const displayPrice = (priceModifier / 100) * putupPrice * quantity
  const formattedPrice = addCommas(roundToTwoPlaces(displayPrice).toFixed(2))
  
  const priceField = document.getElementById(`price-field-${box}`)
  if (priceField) {
    priceField.innerHTML = `Total: $${formattedPrice}`
  }
}

/**
 * Default price modifier calculation from checked checkboxes
 * @param {string} box - The box number
 * @returns {number} Total modifier percentage (100 = no change, 110 = 10% increase)
 */
function calculateDefaultPriceModifier(box) {
  let modifier = 100
  
  const checkboxes = document.querySelectorAll(`#value-added-options-${box} :checked`)
  checkboxes.forEach(checkbox => {
    modifier += parseFloat(checkbox.value)
  })
  
  return modifier
}
